import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { LOAN_GET_LOAN_SECURITY_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class GetLoanLoanSecurity extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = [];

  url = LOAN_GET_LOAN_SECURITY_URL;

  constructor(applicationId) {
    super();
    const paramList = [applicationId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return this.url;
  };

  getBody = () => {
    return this.body;
  };
}
